import { AloftDate, AloftPrice, expected, isDefined } from '@aloft/toolkit-shared';
import { Block, Flex, Icon, IconButton, Typography } from '@aloft/toolkit-sui';

export type PropertyTooltipProps = {
  isSold: boolean;
  beds: string;
  baths: string;
  gla: string;
  photoUrl?: string;
  addressParts: readonly [string, string];
  closeDate?: AloftDate;
  salePrice?: AloftPrice;
  listPrice?: AloftPrice;
};

const PropertyTooltip = ({
  isSold,
  beds,
  baths,
  gla,
  photoUrl,
  addressParts,
  closeDate,
  salePrice,
  listPrice,
}: PropertyTooltipProps) => (
  <Flex minWidth="288px" height="84px">
    <Block flex="1 1 40%" position="relative">
      {photoUrl ? (
        <img
          src={photoUrl}
          key={photoUrl}
          alt=""
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          }}
        />
      ) : (
        <Flex
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          backgroundColor="strokeDefault"
          borderLeftRadius="8px"
        >
          <Icon icon="home-2" size="lg" color="strokeActive" />
        </Flex>
      )}
      {isSold && (
        <Flex
          width="100%"
          height="18px"
          position="absolute"
          bottom="0px"
          left="0px"
          justifyContent="center"
          alignItems="center"
          backgroundColor="surfaceAccent3"
          borderBottomLeftRadius="8px"
        >
          <Typography
            color="textOffset"
            variant="subtitle1"
            __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
          >
            Sold {expected(closeDate).format('M/dd/yy')}
          </Typography>
        </Flex>
      )}
    </Block>
    <Flex flex="1 1 60%" flexDirection="column" padding="8px" paddingTop="2px">
      <Flex alignItems="center" justify="space-between" width="100%">
        <Typography variant="h3" __dangerDoNotUseSx={{ flexGrow: 1 }}>
          {(() => {
            if (isSold && isDefined(salePrice)) {
              return salePrice.toString(true);
            }
            if (isDefined(listPrice)) {
              return listPrice.toString(true);
            }
            return '-';
          })()}
        </Typography>

        <IconButton
          ariaLabel="Copy address"
          icon="file-copy"
          onClick={() => {
            navigator.clipboard.writeText(addressParts[0]).catch(() => {
              console.error('Failed to copy address to clipboard');
            });
          }}
          variant="tertiary"
          size="sm"
        />
      </Flex>

      <Flex justifyContent="space-between" marginBottom="4px">
        <Typography
          variant="subtitle1"
          color="textPrimary"
          __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
        >
          {gla} sf
        </Typography>
        <Typography
          variant="subtitle1"
          color="textPrimary"
          __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
        >
          {beds} bed
        </Typography>
        <Typography
          variant="subtitle1"
          color="textPrimary"
          __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
        >
          {baths} bath
        </Typography>
      </Flex>
      <Block>
        <Typography
          variant="subtitle2"
          color="textTertiary"
          truncate
          casing="none"
          __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
        >
          {addressParts[0]}
        </Typography>
        <Typography
          variant="subtitle2"
          color="textTertiary"
          truncate
          casing="none"
          __dangerDoNotUseSx={{ lineHeight: '0.75rem' }}
        >
          {addressParts[1]}
        </Typography>
      </Block>
    </Flex>
  </Flex>
);

export { PropertyTooltip };
